import {
  BACKUP_ENTITIES,
  type BackupEntity,
  type BackupGroup,
  backupEntitiesOf,
} from '#shared/types';
import { API_BASE } from '#client/lib/api';

export type EntitySelection = ReadonlySet<BackupEntity>;

/**
 * The workbook's address. A plain link, like the importer's downloads; the
 * entity list is one comma-separated parameter because a link has no body.
 */
export function exportUrl(entities: readonly BackupEntity[], from: string, to: string): string {
  const params = new URLSearchParams({ entities: entities.join(',') });
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  return `${API_BASE}/backup/export?${params.toString()}`;
}

/** The selection with `entities` ticked or unticked together. */
export function withEntities(
  selection: EntitySelection,
  entities: readonly BackupEntity[],
  isChecked: boolean,
): EntitySelection {
  const next = new Set(selection);
  for (const entity of entities) {
    if (isChecked) next.add(entity);
    else next.delete(entity);
  }
  return next;
}

/** Sheet order is the shared list's order, whatever order the boxes were ticked in. */
export function selectedInSheetOrder(selection: EntitySelection): BackupEntity[] {
  return BACKUP_ENTITIES.filter((entity) => selection.has(entity));
}

/** How much of a group is ticked, and so whether its button selects or clears. */
export function groupSelection(selection: EntitySelection, group: BackupGroup) {
  const members = backupEntitiesOf(group);
  const chosenCount = members.filter((entity) => selection.has(entity)).length;
  return { members, chosenCount, isComplete: chosenCount === members.length };
}
